import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetExporter  {
    _originalTypeClassName = "zERP.BO.BudgetExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetExporter.translate = translateService;
}
this.BudgetExporterKey = null;
this._key = this.BudgetExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BudgetExporterKey:any;
get BudgetExporterKey(): any {
    return this._BudgetExporterKey;
  }
set BudgetExporterKey(value: any) {
    this._BudgetExporterKey = value;
    this._key = value;
  }

static GetCollectionVariables(budget: any): any{let vars = new window['Map']();
let budgetsChildren = [];
budgetsChildren?.add({
Name: "code",Description: "Κωδικός",}
);
budgetsChildren?.add({
Name: "description",Description: "Περιγραφή",}
);
budgetsChildren?.add({
Name: "amount",Description: "Ποσό",}
);
vars.set({
Name: "INCOME_ACCOUNTS",Description: "Λογαριασμοί εισπράξεων",IsCollection: true,Children: budgetsChildren,}
, Joove.Common.cast(budget?.Details?.linq?.where((d) => !(d?.IsExpense))?.toArray()?.linq?.orderBy((d) => d?.Code)?.toArray(), "System.Collections.List"));
vars.set({
Name: "EXPENSE_ACCOUNTS",Description: "Λογαριασμοί δαπανών",IsCollection: true,Children: budgetsChildren,}
, Joove.Common.cast(budget?.Details?.linq?.where((d) => d?.IsExpense)?.toArray()?.linq?.orderBy((d) => d?.Code)?.toArray(), "System.Collections.List"));
return vars;
}
static ResolveCollectionItem(collectionName: any,varName: any,item: any): any{if (collectionName == "INCOME_ACCOUNTS" || collectionName == "EXPENSE_ACCOUNTS") {let budgetDetail = Joove.Common.cast(item, "Domain.BudgetDetail");switch (varName?.toLowerCase()) {case "code":
{
return budgetDetail?.Code;}
case "description":
{
return budgetDetail?.Description;}
case "amount":
{
return numeral(budgetDetail?.InitialApprovedAmount).format("N");}
}}
return collectionName + "." + varName;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BudgetExporterKey == null || $this.BudgetExporterKey == 0;
            }


}